
import React from "react";
import Layout from "@/components/Layout";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

interface FeatureUpdate {
  id: number;
  title: string;
  description: string;
  date: string;
  category: string;
}

const featureUpdates: FeatureUpdate[] = [
  {
    id: 1,
    title: "Novos Prompts para Área Tributária",
    description: "Adicionamos 15 novos prompts específicos para advogados tributaristas, incluindo modelos para consultas, pareceres e defesas administrativas.",
    date: "15 de maio de 2026",
    category: "Novos Prompts",
  },
  {
    id: 2,
    title: "Estatísticas de Uso Aprimoradas",
    description: "Agora você pode visualizar gráficos detalhados de uso dos seus prompts favoritos, incluindo histórico mensal e comparativos de produtividade.",
    date: "3 de maio de 2026",
    category: "Dashboard",
  },
  {
    id: 3,
    title: "Categorias Personalizáveis",
    description: "Nova funcionalidade permite criar e organizar categorias personalizadas para seus prompts favoritos, facilitando o acesso rápido aos mais utilizados.",
    date: "28 de abril de 2026",
    category: "UX",
  },
  {
    id: 4,
    title: "Integração com Editores de Texto",
    description: "Lançamos uma extensão para navegadores que permite acessar sua biblioteca de prompts diretamente de editores de texto online como Google Docs.",
    date: "15 de abril de 2026",
    category: "Integrações",
  },
  {
    id: 5,
    title: "Novos Prompts para Área Imobiliária",
    description: "Expandimos nossa biblioteca com 12 novos prompts para profissionais do direito imobiliário, incluindo modelos para contratos, notificações e análises.",
    date: "5 de abril de 2026",
    category: "Novos Prompts",
  },
  {
    id: 6,
    title: "Modo Escuro",
    description: "Atendendo a pedidos dos usuários, implementamos o modo escuro para uso noturno e maior conforto visual.",
    date: "28 de março de 2026",
    category: "UX",
  },
];

const Features = () => {
  return (
    <Layout>
      <div className="bg-lawyer-light py-12">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-3xl md:text-4xl font-bold font-display mb-4 text-center text-lawyer-primary">Novidades e Atualizações</h1>
            <p className="text-gray-600 text-center mb-12 text-lg">
              Estamos constantemente melhorando a plataforma com novas funcionalidades e conteúdos.
              Confira abaixo as últimas novidades do LexPrompt.
            </p>
            
            <div className="space-y-6">
              {featureUpdates.map((update) => (
                <Card key={update.id} className="border-l-4 border-l-lawyer-secondary hover:shadow-md transition-shadow">
                  <CardHeader className="pb-2">
                    <div className="flex justify-between items-start">
                      <CardTitle className="text-lg text-lawyer-primary">{update.title}</CardTitle>
                      <span className="text-sm text-gray-500">{update.date}</span>
                    </div>
                    <CardDescription>
                      <span className="inline-block bg-lawyer-light px-2 py-1 rounded text-xs font-medium text-lawyer-primary">
                        {update.category}
                      </span>
                    </CardDescription>
                  </CardHeader>
                  <CardContent>
                    <p className="text-gray-600">{update.description}</p>
                  </CardContent>
                </Card>
              ))}
            </div>
            
            <div className="mt-12 text-center">
              <p className="text-gray-500 text-sm">
                Tem alguma sugestão para uma nova funcionalidade? Envie para <a href="mailto:contato@decidedigital.com.br" className="text-lawyer-accent hover:underline">contato@decidedigital.com.br</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Features;
